import {
  commaSpaceValidator,
  emptyValidator,
  formValidator
} from "../../validators";

const alertValidationStatus = {
  altValue: {
    validators: [emptyValidator()],
    name: "Value",
  },
  altType: {
    validators: [emptyValidator()],
    name: "Alert Type",
  },
  altName: {
    validators: [emptyValidator()],
    name: "Alert Name",
  },
  altStatus: {
    validators: [emptyValidator()],
    name: "Status",
  },
  altActive: {
    validators: [emptyValidator()],
    name: "Active",
  },
  altEvents: {
    validators: [emptyValidator()],
    name: "Event",
  },
};
export const alertValidation = (alertData) => {
  return formValidator(alertData, alertValidationStatus);
};

const fleetAlertValidationStatus = {
  altValue: {
    validators: [emptyValidator()],
    name: "Value",
  },
  altType: {
    validators: [emptyValidator()],
    name: "Alert Type",
  },
  altName: {
    validators: [emptyValidator()],
    name: "Alert Name",
  },
  altStatus: {
    validators: [emptyValidator()],
    name: "Status",
  },
  altActive: {
    validators: [emptyValidator()],
    name: "Active",
  },
  altDefaultTypes: {
    validators: [emptyValidator()],
    name: "Default Types",
  },
};
export const fleetAlertValidation = (alertData) => {
  return formValidator(alertData, fleetAlertValidationStatus);
};
